import { stats, buyingProcessSteps } from '@/mocks/homepage';
import { mainSiteUrl } from '@/mocks/categories';

export default function WhyOopbuy() {
  return (
    <section id="warum" data-product-shop className="py-14 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-1/2">
            <span className="inline-block px-3 py-1 mb-3 text-xs font-medium tracking-wider uppercase rounded-full bg-primary-100 text-primary-700">
              Warum Oopbuy Spreadsheet
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight mb-5">
              Die smarte Wahl für<br />deutsche Käufer
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              Das Oopbuy Spreadsheet wurde speziell für den deutschen Markt entwickelt und optimiert. Es vereint Preisvergleich, Qualitätskontrolle und Zolltransparenz in einer zentralen Plattform — damit Sie sich auf das Wesentliche konzentrieren können: großartige Produkte zu fairen Preisen.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              Anders als herkömmliche Shopping-Tools bietet das Oopbuy Spreadsheet einen integrierten QC-Service, der jedes Produkt vor dem internationalen Versand prüft. Sie erhalten hochauflösende Bilder und können bei Mängeln direkt ablehnen — ohne Risiko, ohne versteckte Kosten.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-3 text-sm font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Alle Kategorien entdecken
              <i className="ri-arrow-right-line"></i>
            </a>

            <div className="flex flex-wrap gap-8 md:gap-12 mt-10">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] max-w-md lg:max-w-none mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20product%20showcase%20of%20curated%20fashion%20pieces%20including%20premium%20sneakers%20a%20leather%20bag%20and%20folded%20garments%20displayed%20on%20a%20soft%20warm%20clay%20colored%20surface%20with%20gentle%20afternoon%20window%20light%20creating%20subtle%20shadows%20modern%20Scandinavian%20minimalist%20aesthetic%20refined%20composition%20cozy%20yet%20sophisticated%20atmosphere&width=600&height=800&seq=why-oopbuy-v2&orientation=portrait"
                alt="Oopbuy Spreadsheet Qualitätskontrolle"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-5">
                <span className="inline-block px-3 py-1 mb-2 text-xs font-medium rounded-full bg-white/20 text-white backdrop-blur-sm">
                  Express-QC · 48h
                </span>
                <p className="text-sm text-white/90">Tracking inklusive</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20">
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-8 text-center">
            So einfach funktioniert das Oopbuy Spreadsheet
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {buyingProcessSteps.map((item) => (
              <div key={item.step} className="bg-background-50 rounded-xl p-5 md:p-6">
                <span className="text-3xl md:text-4xl font-heading font-bold text-primary-200">{item.step}</span>
                <h4 className="text-base font-semibold text-foreground-900 mt-3 mb-2">{item.title}</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}